// Box
export var boxPaddingPropsDict = {
  px: ['padding-right', 'padding-left'],
  py: ['padding-top', 'padding-bottom'],
  pt: 'padding-top',
  pr: 'padding-right',
  pb: 'padding-bottom',
  pl: 'padding-left'
};
export var boxXsPaddingPropsDict = {
  pxXs: ['padding-right', 'padding-left'],
  pyXs: ['padding-top', 'padding-bottom'],
  ptXs: 'padding-top',
  prXs: 'padding-right',
  pbXs: 'padding-bottom',
  plXs: 'padding-left'
};
export var boxMarginPropsDict = {
  mx: ['margin-right', 'margin-left'],
  my: ['margin-top', 'margin-bottom'],
  mt: 'margin-top',
  mr: 'margin-right',
  mb: 'margin-bottom',
  ml: 'margin-left'
};
export var boxXsMarginPropsDict = {
  mxXs: ['margin-right', 'margin-left'],
  myXs: ['margin-top', 'margin-bottom'],
  mtXs: 'margin-top',
  mrXs: 'margin-right',
  mbXs: 'margin-bottom',
  mlXs: 'margin-left'
}; // Grid

export var gridItemPropsDict = {
  col: 'grid-column',
  row: 'grid-row',
  alignSelf: 'align-self',
  justifySelf: 'justify-self',
  colExtend: 'grid-column-end',
  rowExtend: 'grid-row-end'
};
export var gridPropsDict = {
  col: 'grid-template-columns',
  row: 'grid-template-rows',
  autoCol: 'grid-auto-columns',
  autoRow: 'grid-auto-rows',
  gap: 'grid-gap',
  gapRow: 'grid-row-gap',
  gapCol: 'grid-column-gap',
  justifyItems: 'justify-items',
  alignItems: 'align-items',
  justifyContent: 'justify-content',
  alignContent: 'align-content'
};